import { computed, Injectable, signal } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';

export interface JobViewerState {
  unsubmittedInvoiceTotalPayable: number;
}

const initialState: JobViewerState = {
  unsubmittedInvoiceTotalPayable: null
};

@Injectable()
export class JobViewerStore extends ComponentStore<JobViewerState> {
  unsubmittedInvoiceTotalPayable = this.selectSignal((state) => state.unsubmittedInvoiceTotalPayable);

  hasNegativeUnsubmittedInvoice = computed(() => this.unsubmittedInvoiceTotalPayable() < 0);
  noQuoteResponseSaved = signal(false);

  constructor() {
    super(initialState);
  }

  setUnsubmittedInvoiceTotalPayable(unsubmittedInvoiceTotalPayable: number): void {
    this.patchState({ unsubmittedInvoiceTotalPayable });
  }
}
